module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec01_sp_9c1c3aa4badc493d93dd7fcf44052875.jpg";